import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from 'components/CncUI/Typography';
import Button from 'components/CncUI/Button';
import Checkbox from 'components/CncUI/Checkbox';
import AddressSearchField from 'components/SearchFieldAddress';

const useStyles = makeStyles(() => ({
  header: {
    marginBottom: 0,
  },
  actions: {
    marginTop: 24,
    marginBottom: -16,
  },
}));

const compareAddresses = (primary, mailing) => {
  if (!primary || !mailing) return false;
  const same = type => primary[type] === mailing[type];
  return (
    same('city') &&
    same('state') &&
    same('addressLine1') &&
    same('addressLine2') &&
    same('zipCode')
  );
};

const EditForm = props => {
  const classes = useStyles();
  const { mailing, primary, dbCode } = props;
  const { onCancel, onSave } = props;
  const [loading, setLoading] = useState(false);
  const [primaryAddress, setPrimaryAddress] = useState(primary);
  const [mailingAddress, setMailingAddress] = useState(mailing);
  const [sameAddress, setSameAddress] = useState(
    !mailing || !mailing.addressLine1 || compareAddresses(primary, mailing),
  );

  const save = () => {
    // don't save unchanged addresses
    const addressesToSave = [];
    if (primaryAddress !== primary) {
      addressesToSave.push(primaryAddress);
    }

    if (
      sameAddress &&
      primaryAddress &&
      !compareAddresses(primaryAddress, mailingAddress)
    ) {
      const { __typename, ...address } = primaryAddress;
      addressesToSave.push({
        ...address,
        typeofContact: mailing.typeofContact,
      });
    } else if (mailingAddress !== mailing) {
      addressesToSave.push(mailingAddress);
    }

    if (addressesToSave.length > 0) {
      setLoading(true);
      onSave({
        basicInfo: { dbCode, sameasprimaryAddress: sameAddress },
        addresses: addressesToSave,
      });
    } else {
      onCancel();
    }
  };

  const longAddress = addressFormData => {
    const { city, state, zipCode } = addressFormData;
    const { addressLine1, addressLine2 } = addressFormData;
    const address = [addressLine1, addressLine2].filter(Boolean).join(' ');
    const stateZipCode = [state, zipCode].filter(Boolean).join(' ');
    return [address, city, stateZipCode].filter(Boolean).join(', ');
  };

  const onAddressSelect = (selected, address, setAddress) => {
    setAddress({
      city: selected.City,
      state: selected.ProvinceCode,
      addressLine1: selected.Line1,
      addressLine2: selected.Line2,
      addressLine3: selected.Line3,
      typeofContact: address.typeofContact,
      zipCode: selected.PostalCode,
      country: selected.CountryIso2,
    });
  };

  const selectPrimary = data =>
    onAddressSelect(data, primaryAddress, setPrimaryAddress);
  const selectMailing = data =>
    onAddressSelect(data, mailingAddress, setMailingAddress);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5" className={classes.header}>
          Permanent Address
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <AddressSearchField
          label="Search permanent address"
          onSelect={selectPrimary}
          value={longAddress(primaryAddress)}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h5" className={classes.header}>
          Mailing Address
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Checkbox
          checked={sameAddress}
          onChange={e => setSameAddress(e.target.checked)}
        >
          Same as permanent address above
        </Checkbox>
      </Grid>

      {!sameAddress && (
        <Grid item xs={12}>
          <AddressSearchField
            label="Search mailing address"
            onSelect={selectMailing}
            value={longAddress(mailingAddress)}
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <Grid
          container
          spacing={2}
          justify="flex-end"
          className={classes.actions}
        >
          <Grid item>
            <Button
              secondary
              disabled={loading}
              onClick={onCancel}
              id="Addresses-CancelButton"
            >
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button loading={loading} onClick={save} id="Addresses-SaveButton">
              Save
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EditForm;
